import { z } from "zod/v4";
import { expenseResponseSchema } from "../../schemas/finance";
import { fetchApi, fetchVoid } from "../client/internal";

export const expenses = {
	list: (
		clubId: string,
		params?: {
			from?: string;
			to?: string;
			account_id?: string;
			vendor?: string;
		},
	) => {
		const qs = new URLSearchParams();
		if (params?.from) qs.set("from", params.from);
		if (params?.to) qs.set("to", params.to);
		if (params?.account_id) qs.set("account_id", params.account_id);
		if (params?.vendor) qs.set("vendor", params.vendor);
		const q = qs.toString();
		return fetchApi(`/${clubId}/expenses${q ? `?${q}` : ""}`, z.array(expenseResponseSchema));
	},
	create: (clubId: string, data: unknown) =>
		fetchApi(`/${clubId}/expenses`, expenseResponseSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (clubId: string, expenseId: string, data: unknown) =>
		fetchApi(`/${clubId}/expenses/${expenseId}`, expenseResponseSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, expenseId: string) =>
		fetchVoid(`/${clubId}/expenses/${expenseId}`, { method: "DELETE" }),
};
